import { theme as antdTheme } from "antd";

export const COLLAPSED_WIDTH = 56;

// color palettes: triadic #A1A7CB, #CBA1A7, #A7CBA1
// 10 color objects of primary #2378c3 as generated by https://smart-swatch.netlify.app/#2378c3
// This is for reference purposes

export const COLOR = {
    50: "#e0f1ff",
    100: "#b0d2ff",
    200: "#7fb0ff",
    300: "#4d8bff",
    400: "#1e79fe",
    500: "#076ee5",
    600: "#0062b3",
    700: "#004f81",
    800: "#003650",
    900: "#001620",
    borderColor: "#E7EAF3B2",
};

const baseTheme = {
    cssVar: true, 
    hashed: false,//https://ant-design.antgroup.com/docs/react/css-variables-cn#%E5%85%B3%E9%97%AD-hash
    token: {
        colorPrimary: COLOR["500"],
        borderRadius: 6,
        // fontFamily: "Lato, sans-serif",
        //fontSize: 15,
    },
    components: {
        Menu: {
            collapsedWidth: COLLAPSED_WIDTH,
        },
        Breadcrumb: {
            // linkColor: 'rgba(0,0,0,.8)',
            // itemColor: 'rgba(0,0,0,.8)',
        },
        Button: {
            // colorLink: COLOR["500"],
            // colorLinkActive: COLOR["700"],
            // colorLinkHover: COLOR["300"],
        },
        Calendar: {
            colorBgContainer: "none",
        },
        Card: {
            colorBorderSecondary: COLOR["borderColor"],
        },
        Carousel: {
            colorBgContainer: COLOR["800"],
            dotWidth: 8,
        },
        Rate: {
            colorFillContent: COLOR["100"],
            colorText: COLOR["600"],
        },
        Segmented: {
            colorBgLayout: COLOR["100"],
            borderRadius: 6,
            colorTextLabel: "#000000",
        },
        Table: {
            //borderColor: COLOR["100"],
            // colorBgContainer: "none",
            // headerBg: "none",
            // rowHoverBg: COLOR["50"],
        },  
        Tree: {
            /* 这里是你的组件 token */
            //titleHeight: 36,
            //indentSize: 36,
        },
        Tabs: {
            colorBorderSecondary: COLOR["100"],
        },
        Timeline: {
            dotBg: "none",
        },
        Typography: {
            colorLink: COLOR["500"],
            colorLinkActive: COLOR["700"],
            colorLinkHover: COLOR["300"],
            linkHoverDecoration: "underline",
        },
    },
};

/**
 * 自定义的Ant Design浅色主题配置
 *
 * English: Custom Ant Design light theme configuration
 *
 * @see https://ant.design/theme-editor-cn (中文版)
 * @see https://ant.design/docs/react/customize-theme-cn (中文版配置指南)
 * @see https://ant.design/theme-editor (English version)
 * @see https://ant.design/docs/react/customize-theme (English version configuration guide)
 */
export const customAntdLightTheme = {
    ...baseTheme,
    algorithm: antdTheme.defaultAlgorithm,
};

/**
 * 自定义的Ant Design深色主题配置
 *
 * English: Custom Ant Design dark theme configuration
 *
 * @see https://ant.design/theme-editor-cn (中文版)
 * @see https://ant.design/docs/react/customize-theme-cn (中文版配置指南)
 * @see https://ant.design/theme-editor (English version)
 * @see https://ant.design/docs/react/customize-theme (English version configuration guide)
 */
export const customAntdDarkTheme = {
    ...baseTheme,
    algorithm: antdTheme.darkAlgorithm,
};

export const styleContextValue = {
    rowProps: {
        gutter: [
            { xs: 8, sm: 16, md: 24, lg: 32 },
            { xs: 8, sm: 16, md: 24, lg: 32 },
        ],
    },
    carouselProps: {
        autoplay: true,
        dots: true,
        dotPosition: "bottom",
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
    },
};
